/* ==========================================================================
   LAUZON — newsletter signup (footer band, First Access band, page hero).

   Takes over the footer's Klaviyo form and posts it in the background, so a
   visitor who signs up is never navigated away from whatever they were
   reading. Without JS the form still works: its action and hidden fields are
   a real Klaviyo list-subscribe post, and the browser submits it normally.

   WHY THE OLD-STYLE ENDPOINT. manage.kmail-lists.com/ajax/subscriptions/
   subscribe takes a plain form POST and answers with JSON. Klaviyo's newer
   /client/subscriptions/ endpoint wants a JSON body with a revision header,
   which cannot be submitted by a plain <form> — so the no-JS path would be
   dead, and a signup that silently fails for a fraction of visitors is worse
   than one that costs a page load.

   The public company id is safe in page source by design: it can create a
   subscription and nothing else.

   THE ?src= SOURCE OVERRIDE (2026-09-07). A form may publish a WHITELIST of
   $source values as data-source-map, a JSON object of {key: "Source value"}.
   A visitor arriving on ?src=key gets that value stamped on their Klaviyo
   profile instead of the form's configured one. That is what lets two ads
   pointing at one page be scored on signups per arm rather than on clicks,
   which routinely disagree.

   🔴 IT IS A WHITELIST AND MUST STAY ONE. Only a value the FORM published is
   ever written; the URL supplies a key to look up, never a value. Writing an
   arbitrary query string into a profile property would let anyone with the
   link pollute the list, and would put unvalidated text into Klaviyo.

   A form with no map is never overridden, which is deliberate: the footer
   band sends "Website footer" from every page and a campaign parameter has
   no business restamping it.

   The override is applied at init rather than at submit, so the value in the
   DOM is the value that will be sent and can be read straight off the page.
   The no-JS path cannot see the URL and posts the configured Source — an
   accepted loss, because it is a fallback nobody is targeting.

   Everything is idempotent (data flag) and re-runs on shopify:section:load
   so the theme editor stays live.
   ========================================================================== */

(function () {
  'use strict';

  var ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  /* Reads ?src= and, only if the form itself published that key, rewrites the
     hidden $source field. Every failure path leaves the configured value in
     place: no map, no parameter, unparseable JSON, unknown key, empty value. */
  function applySourceOverride(form) {
    var raw = form.getAttribute('data-source-map');
    if (!raw || !window.URLSearchParams) return;

    var map;
    try {
      map = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!map || typeof map !== 'object') return;

    var key = new URLSearchParams(window.location.search).get('src');
    if (!key) return;
    key = key.trim().toLowerCase();

    // Match case-insensitively so ?src=Ad and ?src=ad both resolve, without
    // asking whoever writes the ad URL to remember which one the box used.
    var value = null;
    Object.keys(map).forEach(function (mapKey) {
      if (String(mapKey).trim().toLowerCase() === key) value = map[mapKey];
    });
    if (typeof value !== 'string' || !value) return;

    var field = form.querySelector('input[name="$source"]');
    if (field) field.value = value;
  }

  function setStatus(el, message, state) {
    if (!el) return;
    el.textContent = message;
    el.classList.remove('is-error', 'is-success');
    if (state) el.classList.add(state);
  }

  function initSignup(root) {
    root.querySelectorAll('[data-klaviyo-form]').forEach(function (form) {
      if (form.dataset.signupInit) return;
      form.dataset.signupInit = '1';

      applySourceOverride(form);

      var status = form.querySelector('[data-signup-status]');
      var button = form.querySelector('button[type="submit"]');
      var input = form.querySelector('input[type="email"]');
      var rest = status ? status.getAttribute('data-rest') || '' : '';

      form.addEventListener('submit', function (e) {
        var companyId = form.getAttribute('data-company-id');
        var listId = form.getAttribute('data-list-id');
        // Misconfigured in the editor: let the browser do its normal thing
        // rather than swallowing the submit and reporting nothing.
        if (!companyId || !listId || !window.fetch) return;

        e.preventDefault();
        if (button) button.disabled = true;
        setStatus(status, 'One moment…');

        var body = new URLSearchParams();
        body.set('g', listId);
        body.set('email', input ? input.value : '');
        body.set('$fields', '$source');
        body.set('$list_fields', '$source');
        var source = form.querySelector('input[name="$source"]');
        if (source) body.set('$source', source.value);

        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            // Klaviyo answers 200 with {success: false, errors: [...]} for a
            // bad address, so the HTTP status alone is not the answer.
            if (data && data.success) {
              setStatus(status, 'You are on the list. Watch your inbox.', 'is-success');
              form.reset();
            } else {
              var msg = (data && data.errors && data.errors[0]) || 'That address did not go through. Try again?';
              setStatus(status, msg, 'is-error');
            }
          })
          .catch(function () {
            setStatus(status, 'Could not reach the mailing list. Try again in a moment.', 'is-error');
          })
          .then(function () {
            if (button) button.disabled = false;
            // Put the fine print back after the result has had time to be
            // read — and announced — rather than leaving a stale message
            // sitting under the field for the rest of the session.
            window.setTimeout(function () {
              if (status && status.classList.contains('is-success')) return;
              setStatus(status, rest);
            }, 8000);
          });
      });
    });
  }

  initSignup(document);

  document.addEventListener('shopify:section:load', function (event) {
    initSignup(event.target);
  });
})();
